"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeaturedMediaProperty = exports.featuredMediaPropertyDefinition = void 0;
exports.featuredMediaPropertyDefinition = {
    view: {
        label: 'Featured image',
        hint: 'Used to represent the story on collection pages. Add multiple images to trigger an image carousel.',
    },
    constraints: [
        {
            name: 'required',
            argument: true,
        },
        {
            name: 'stencils',
            argument: ['image'],
        },
    ],
    type: 'asset',
    multiple: true,
    name: 'featured-media',
};
const isFeaturedMediaProperty = (prop) => {
    return prop.name === exports.featuredMediaPropertyDefinition.name;
};
exports.isFeaturedMediaProperty = isFeaturedMediaProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZmVhdHVyZWQtbWVkaWEucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9mZWF0dXJlZC1tZWRpYS5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLCtCQUErQixHQUFHO0lBQzdDLElBQUksRUFBRTtRQUNKLEtBQUssRUFBRSxnQkFBZ0I7UUFDdkIsSUFBSSxFQUFFLG9HQUFvRztLQUMzRztJQUNELFdBQVcsRUFBRTtRQUNYO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLElBQUk7U0FDZjtRQUNEO1lBQ0UsSUFBSSxFQUFFLFVBQVU7WUFDaEIsUUFBUSxFQUFFLENBQUMsT0FBTyxDQUFDO1NBQ3BCO0tBQ0Y7SUFDRCxJQUFJLEVBQUUsT0FBTztJQUNiLFFBQVEsRUFBRSxJQUFJO0lBQ2QsSUFBSSxFQUFFLGdCQUFnQjtDQUNTLENBQUE7QUFJMUIsTUFBTSx1QkFBdUIsR0FBRyxDQUFDLElBQWtCLEVBQWlDLEVBQUU7SUFDM0YsT0FBTyxJQUFJLENBQUMsSUFBSSxLQUFLLHVDQUErQixDQUFDLElBQUksQ0FBQTtBQUMzRCxDQUFDLENBQUE7QUFGWSxRQUFBLHVCQUF1QiwyQkFFbkMifQ==